var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4721 31.6111C33.6437 31.6111 32.9721 32.2827 32.9721 33.1111C32.9721 33.9395 33.6437 34.6111 34.4721 34.6111V31.6111ZM7.83325 10.5C7.00482 10.5 6.33325 11.1716 6.33325 12C6.33325 12.8284 7.00482 13.5 7.83325 13.5V10.5ZM41.7499 31.6111H34.4721V34.6111H41.7499V31.6111ZM42.9999 30.3575C42.9999 31.0517 42.4384 31.6111 41.7499 31.6111V34.6111C44.099 34.6111 45.9999 32.7048 45.9999 30.3575H42.9999ZM42.9999 14.7536V30.3575H45.9999V14.7536H42.9999ZM41.7499 13.5C42.4384 13.5 42.9999 14.0594 42.9999 14.7536H45.9999C45.9999 12.4063 44.099 10.5 41.7499 10.5V13.5ZM7.83325 13.5H41.7499V10.5H7.83325V13.5Z",
    fill: "#727272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7222 19.7778H6.5C5.39543 19.7778 4.5 20.6733 4.5 21.7778V34.4445C4.5 35.5491 5.39543 36.4445 6.5 36.4445H24.7222C25.8268 36.4445 26.7222 35.5491 26.7222 34.4445V21.7778C26.7222 20.6733 25.8268 19.7778 24.7222 19.7778Z",
    stroke: "#727272",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16675 22.5556L15.5245 29.2222L25.6112 22",
    stroke: "#727272",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.94f97b797a977320b40154e2c1096fa9.svg";
export { ForwardRef as ReactComponent };